// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1-et8","error":"Textarea_error__2_uhr","readonly":"Textarea_readonly__1Wszd","disabled":"Textarea_disabled__2Sa50"};